import { render, staticRenderFns } from "./DevPageKD2.vue?vue&type=template&id=01e2d661&scoped=true"
import script from "./DevPageKD2.vue?vue&type=script&lang=js"
export * from "./DevPageKD2.vue?vue&type=script&lang=js"
import style0 from "./DevPageKD2.vue?vue&type=style&index=0&id=01e2d661&prod&lang=css"
import style1 from "./DevPageKD2.vue?vue&type=style&index=1&id=01e2d661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e2d661",
  null
  
)

export default component.exports